import { getTrafficType as getTrafficTypeCookieValue } from 'dibs-cookie-jar';
import { type Cookie } from 'dibs-cookie-jar/exports/types';
import { isBot } from './bot.utils';

const BT_TRAFFIC = 'bt';

function getTrafficType(cookie: Cookie, url: URL | null): string | null {
    if (isBot()) {
        return BT_TRAFFIC;
    }

    const trafficTypeCookieValue = getTrafficTypeCookieValue(cookie, url);

    if (trafficTypeCookieValue) {
        return trafficTypeCookieValue;
    }

    return null;
}

export { getTrafficType };
